const ALL_KEYS = [
  'bilan_personnel','bilan_patrimonial','situation_fiscale','objectifs',
  'strategie_investissement','strategie_immobiliere','prevoyance_protection',
  'retraite','transmission_succession','recommandations_plan_action',
]
const LABELS = {
  bilan_personnel: 'Personnel',
  bilan_patrimonial: 'Patrimoine',
  situation_fiscale: 'Fiscal',
  objectifs: 'Objectifs',
  strategie_investissement: 'Investissement',
  strategie_immobiliere: 'Immobilier',
  prevoyance_protection: 'Prévoyance',
  retraite: 'Retraite',
  transmission_succession: 'Transmission',
  recommandations_plan_action: 'Recommandations',
}

export default function SectionNav({ counts, activeKey, onSelect }) {
  const populated = ALL_KEYS.filter(k => counts[k] > 0)
  const empty = ALL_KEYS.filter(k => !counts[k])
  return (
    <div>
      <div className="mb-2 px-1 text-[10px] font-medium uppercase tracking-[1.5px] text-muted">
        Sections · {Object.values(counts).reduce((a, b) => a + b, 0)} faits
      </div>
      <ul className="space-y-0.5 text-[13px]">
        {populated.map(k => {
          const active = k === activeKey
          return (
            <li key={k}>
              <button
                onClick={() => onSelect?.(k)}
                className={`flex w-full items-center justify-between rounded-md px-2 py-1.5 text-left ${active ? 'bg-terra-50 font-semibold text-terra-500' : 'hover:bg-line/40'}`}
              >
                <span>{active ? '● ' : ''}{LABELS[k]}</span>
                <span className="text-[11px] text-muted">{counts[k]}</span>
              </button>
            </li>
          )
        })}
        {empty.length > 0 && (
          <li className="px-2 pt-2 text-[12px] italic text-muted/70">+ {empty.length} sections vides</li>
        )}
      </ul>
    </div>
  )
}
